import React from "react";

import TeamImg01 from "./../../assets/AyurvedaAssets/images/team-member/team-img01.png";
import TeamImg02 from "./../../assets/AyurvedaAssets/images/team-member/team-img02.png";
import TeamImg03 from "./../../assets/AyurvedaAssets/images/team-member/team-img03.png";
import TeamImg04 from "./../../assets/AyurvedaAssets/images/team-member/team-img04.png";
import TeamImg05 from "./../../assets/AyurvedaAssets/images/team-member/team-img05.png";
import TeamImg06 from "./../../assets/AyurvedaAssets/images/team-member/team-img06.png";
import TeamImg07 from "./../../assets/AyurvedaAssets/images/team-member/team-img07.png";
import TeamImg08 from "./../../assets/AyurvedaAssets/images/team-member/team-img08.png";
import OmkarMittal from "./../../assets/AyurvedaAssets/images/team-member/Omkar Mittal.png";
import PMBhardwaj from "./../../assets/AyurvedaAssets/images/team-member/PMBhardwaj.png";


export default function TeamListing() {
  const doctors = [
    {
      img: TeamImg01,
      name: " Dr. Kamal Taori, IAS  Retd.",
      role: "Mentor and Strategic Visionary Leader",
      consultations:
        "Former Secretary, Government of Bharat | Author (50+ books) | Global Thought Leader | Pioneer of Vision-in-Action (VIA)",
    },
    {
      img: TeamImg03,
      name: "Shri Prashant Chaturvedi ji",
      role: " Honorary Advisor & Ayurveda,Panchgavya Wellness Mentor ",
      consultations:
        "Associate of Rajiv Dixit Ji, traditional Ayurveda and pain management mentor, Ayurveda & Panchgavya health researcher, and holistic lifestyle guide.",
    },
    {
      img: PMBhardwaj,
      name: "Dr. P. M. Bhardwaj",
      role: "Chief Advisor, Growth Strategy & Expansion Strategist",
      consultations:
        "Motivational & management guru; Founder—Bhardwaj Foundation; Chief Advisor—Gau Maya; ex-CMD (4 PSUs); Advisor—Gau MahaKumbh/Run ’25; ex-Board & GoI Industrial Advisory; Dist. Chair—Skill Dev., RID 3056.",
    },
     {
      img: TeamImg02,
      name: "Dr. Radha Kant Vats",
      role: "Honorary Advisor & Expert Ayurvedacharya",
      consultations:
        "Doctor of the Body & Mind — specialist in chronic/‘incurable’ diseases; BAMS (1988), L.H.S.T.",
    },
        {
     img: OmkarMittal,
      name: "Shri Omkar Mittal",
      role: "Bharat Dhara Advisor Panel, 40+ years of experience",
       },
    {
      img: TeamImg04,
      name: "Shri Ompal Singh",
      role: "Director & Founder - Bharar Dhara | अपर जिला कृषि अधिकारी Retd., Muzaffarnagar ",
      consultations:
        "Veteran agri officer; guiding Bharat Dhara with global rural-development insight.",
    },
    {
      img: TeamImg08,
      name: "Shri Dheeraj Ahalawat",
      role: "Manager Operation",
      consultations:  "Dheeraj Ahlawat is a core Bharat Dhara operations lead, known for steady execution and ground-level coordination.",
    },
    {
      img: TeamImg06,
      name: "Anjali Mamgain",
      role: "Program Architect Rural Value Chains And Holistic Health Models",
      consultations: "Seasoned operations leader driving innovation and growth in AI-powered business intelligence. Known for strategic execution and building scalable tech-driven solutions.",
    },
    {
      img: TeamImg05,
      name: "Shri Jeevan Chand Upreti Ji (“Jeevanand”)",
      role: "Yogacharya & Spiritual Mentor, Bharat Dhara",
      consultations:
        "Yoga & Spiritual Guru | Certified Yoga Instructor – Ministry of AYUSH, Government of India Vice President – Yoga & Naturopathy Practitioners Association of India, New Delhi",
    },

    {
      img: TeamImg07,
      name: "Bhai Brahm Prashant",
      role: "The Holistic Health Visionary & Global Wellness Ambassador",
      consultations:
        "“Cut the impossible – I am Possible.” Creator of the Sattayu Health Model, blending Usha Kriya, Ayurveda & self-healing to make every home a self-reliant clinic.",
    },



  ];
  return (
    <section className="prt-row team-section01 clearfix">
      <div className="container">
        <div
          className="row row-equal-height"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {doctors.map((doc, idx) => (
            <div key={idx} className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
              <div className="featured-imagebox featured-imagebox-team style1">
                <div className="featured-thumbnail">
                  <img
                    width="303"
                    height="327"
                    src={doc.img}
                    alt={doc.name}
                    className="img-fluid"
                  />
                </div>
                <div className="featured-content">
                  <div className="featured-title-box">
                    <div className="featured-title">
                      <h3>
                        <a href="team-details.html">{doc.name}</a>
                      </h3>
                    </div>
                    <div className="featured-position">
                      <p>{doc.role}</p>
                    </div>
                  </div>
                  <div className="prt-history">
                    <p>
                      <i className="fa fa-check-circle"></i> {doc.consultations}{" "}
                     {/* Consultation done*/}
                    </p>
                    <div className="d-flex">
                      {/* <span>4.8</span>
                      <div className="team-rating-star">
                        {[...Array(5)].map((_, i) => (
                          <i
                            key={i}
                            className="fa fa-star"
                            aria-hidden="true"
                          ></i>
                        ))}
                      </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
